
export const MAX_LIMIT_CATEGORY_ARTICLES = 50;